/**
 * assets/ecom-filter-label-fix.js
 *
 * Makes clicking a collection filter's TEXT check that filter's checkbox.
 *
 * THE BUG: EcomPoser renders its filter list twice per collection page — a
 * mobile modal form and a desktop sidebar form — and gives both copies the
 * same input id, `ecom-filter-<Filter Label>-<index>`. Per the HTML spec a
 * <label for="..."> is bound to whatever that id resolves to, and that
 * binding beats the input nested inside the label. Both labels therefore
 * pointed at the FIRST copy in the DOM (the hidden mobile input), so
 * clicking a filter's text toggled an invisible checkbox. The products still
 * filtered — EcomPoser's handler serializes both forms — but the checkbox
 * the shopper clicked never changed. Clicking the box itself worked, because
 * that skips the label indirection.
 *
 * THE FIX: drop the `for` attribute. The input is nested inside the label,
 * so implicit association takes over and the label binds to its own input —
 * always the correct one, no matter how many duplicate ids exist.
 *
 * WHY THIS LIVES IN JS: the markup is generated by the EcomPoser app, not
 * hand-written. Re-publishing a page from the app rewrites its section file
 * and would wipe any Liquid-side fix, and every new template the client
 * builds ships the same duplicate ids. Patching at runtime covers all
 * collection templates, current and future, and survives regeneration.
 */
(function () {
  var LABEL_SELECTOR = 'label.ecom-collection__filters-group-checkbox[for]';

  function unbindLabel(label) {
    // Only safe when the label actually wraps its own control. If it doesn't,
    // removing `for` would leave the input with no accessible name at all.
    if (label.querySelector('input')) label.removeAttribute('for');
  }

  function unbindWithin(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(LABEL_SELECTOR)) unbindLabel(root);
    var labels = root.querySelectorAll(LABEL_SELECTOR);
    for (var i = 0; i < labels.length; i++) unbindLabel(labels[i]);
  }

  function init() {
    unbindWithin(document);

    // EcomPoser's AJAX filtering only swaps the product grid, so the filter
    // markup normally survives untouched — but watch each filter form anyway
    // in case a filter group is re-rendered or injected later.
    if (!window.MutationObserver) return;
    var forms = document.querySelectorAll('.ecom-collection__filters-form');
    if (!forms.length) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) unbindWithin(added[j]);
      }
    });
    for (var k = 0; k < forms.length; k++) {
      observer.observe(forms[k], { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
